import {AbstractControl, ValidatorFn} from '@angular/forms';

import * as moment_ from 'moment';

import {MaxDateValidatorKey} from './custom-validator-keys';

const moment = moment_;

export function MaxDateValidator(date: string): ValidatorFn {
    return (control: AbstractControl): { [MaxDateValidatorKey]: boolean } | null => {
        if (!moment(date).isValid()) {
            console.warn('Invalid date for comparison.');

            return null;
        }

        const controlValue = control.value;

        if (controlValue) {
            const baseDate = moment(date).utc(false);

            const controlDate = moment(controlValue).utc(false);

            if (controlDate.isSameOrAfter(baseDate)) {
                return {[MaxDateValidatorKey]: true};
            }
        }

        return null;
    };
}
